import React from 'react'
import { Box } from '@mui/material'
import usePlacesAutocomplete, {
    getGeocode,
    getLatLng,
} from 'use-places-autocomplete'
import {
    Combobox,
    ComboboxInput,
    ComboboxPopover,
    ComboboxList,
    ComboboxOption,
} from '@reach/combobox'
import '../css/reachcombobox.css'
const searchStyles = {
    position: 'absolute',
    top: '0.5rem',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    maxWidth: '25rem',
    zIndex: '10',
    fontFamily: 'Roboto Arial, Helvetica, sans-serif',
    border: 'solid 1.5px white',

    lineHeight: '1.5rem',
    '& > div > input': {
        width: '100%',
        textAlign: 'center',
        fontWeight: '600',
    },
}

export default function GglPlacesSearch({ panTo }) {
    const {
        ready,
        value,
        suggestions: { status, data },
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete({
        // requestOptions: {   If this parameter is not specified, the API uses IP address biasing by default.
        //     locationBias: { lat: 40, lng: -98 },
        // },
    })
    // TODO: 06/07/24 create proper error handling blo
    return (
        <Box sx={searchStyles}>
            <Combobox //  support  https://www.youtube.com/watch?v=WZcxJGmLbSo&t=367s
                onSelect={async (address) => {
                    setValue(address, false)
                    clearSuggestions()
                    try {
                        const results = await getGeocode({ address })
                        // console.log('results', results)
                        const { lat, lng } = await getLatLng(results[0])
                        panTo({ lat, lng })

                        // console.log('lat lng', lat, lng)
                    } catch (error) {
                        // console.log(
                        //     'Error in Combobox getGeocode getLatLng calls',
                        //     error
                        // )
                    }

                    // console.log(address)
                }}
            >
                <ComboboxInput
                    value={value}
                    onChange={(e) => {
                        setValue(e.target.value)
                    }}
                    disabled={!ready}
                    placeholder="Enter your fence site address"
                />
                <ComboboxPopover>
                    <ComboboxList>
                        {status === 'OK' &&
                            data.map(({ place_id, description }) => (
                                <ComboboxOption
                                    key={place_id}
                                    value={description}
                                />
                            ))}
                    </ComboboxList>
                </ComboboxPopover>
            </Combobox>
        </Box>
    )
}
